export const FIGMA_PLUGIN_URL =
  "https://www.figma.com/community/plugin/1632806800145699898";

export const AUDIT_URL_INPUT_ID = "audit-url";
export const START_AUDIT_HREF = `/#${AUDIT_URL_INPUT_ID}`;

/** Curated homepage demo audits, by job id. Single source of truth shared
 *  by the demo gallery (fallback when /api/demos is empty — which is the
 *  live situation: these rows were never flagged in the DB) and the /s
 *  share page, which uses it to label these as "Live demo audit" instead
 *  of "Shared audit". Durable fix: flag the rows via setJobDemo so
 *  /api/demos serves them and this list can retire. */
export const PRIMARY_DEMO_JOB_ID = "JxEDKb2_wRTf"; // Figma

export const DEMO_JOB_IDS: string[] = [
  PRIMARY_DEMO_JOB_ID,
  "2Kw4AfnhTEyJ", // Stripe
  "cGIS9azymQvI", // AirBNB
  "H3x65WEcol-8", // IMDb
  // Add more audit ids here to feature them in the gallery.
];

export const SUPPORT_EMAIL = "support@snapsiteux.com";

/** Canonical product branding. Used anywhere we stamp Snap Site on
 *  user-facing output (e.g. the copy-findings export, PDFs). Keep the URL
 *  bare (no scheme) so it reads cleanly inline; BRAND_URL carries the full
 *  link for places that want a clickable href. */
export const BRAND = {
  name: "Snap Site",
  domain: "snapsiteux.com",
  url: "https://snapsiteux.com",
  tagline: "Turn any URL into an annotated UX & accessibility audit.",
};

export const CREATOR = {
  name: "Dhwani Khara",
  url: "https://dhwanikhara.com",
};

/** Dhwani's design agency. URL TBD — render as plain text until provided. */
export const DESIGN_AGENCY = {
  name: "DesignRight",
};

export const PARENT_COMPANY = {
  name: "CyberSky",
  url: "https://thecybersky.com",
};
